import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/nextjs'
import { allowStorage } from '../../utils/allow.storage'
import { ID } from '../../utils/id'
import { MessageInstance } from 'antd/es/message/interface'

export const companySlice = createSlice({
  initialState: () => {
    if (!allowStorage()) {
      return {
        id: undefined,
      }
    }

    return {
      id: localStorage.getItem('company') || undefined,
    }
  },
  name: 'company',
  reducers: {
    setCompanyId: (state, action: PayloadAction<{
      id: ID
      message: MessageInstance
    }>) => {
      const { message, id } = action.payload

      if (id) {
        try {
          localStorage.setItem('company', `${id}`)
        } catch (e) {
          Sentry.captureException(e)
          void message.warning({
            content: 'There no storage available!',
          })
        }

        Sentry.setTag('company', `${id}`)

        return {
          id,
        }
      } else {
        localStorage.removeItem('company')

        return {
          id: undefined,
        }
      }
    },
  },
})

export const { setCompanyId } = companySlice.actions

